import { memo } from 'react';
import { Lozenge } from 'shared/lozenge/Lozenge';
import { KCFColor } from 'styles/themes/KCFColor';

type StatusLozengeProps = Readonly<{
    status?: string;
    color: string;
}>;

function StatusLozenge({ status, color }: StatusLozengeProps) {
    return (
        <div>
            <Lozenge color={KCFColor.white} backgroundColor={color}>
                {status?.toUpperCase()}
            </Lozenge>
        </div>
    );
}

const memoStatusLozenge = memo(StatusLozenge);
export { memoStatusLozenge as StatusLozenge };
